import { useEffect, useRef, useState } from 'react';
import { StyledLabel } from '../../assets/styledComponents/Global';
import theme from '../../utils/themes';
import styled from 'styled-components';
import StyledButton from '../../app/components/styledComponents/StyledButton';
import DownloadIcon from '../../app/components/svgIcons/DownloadIcon';
import InterviewDone from './InterviewDone';
import WelcomeVideoProfile from './WelcomeVideoProfile';
import StartInterviewScreen from './StartInterviewScreen';
import GettingReadyAssessment from './GettingReadyAssessment';
import { useGetClientVideoProfileDetailsQuery, useGetCompanyInfoQuery, usePreSignedVpUrlMutation, useStartSessionMutation, useSubmitVideoProfileMutation, useUploadVPAnswerMutation, } from '../Setting/VideoProfiling/VideoProfileApiSlice';
import { Spinner } from '../../app/components/loader/EllipticalLoader';
import { isObject } from 'lodash';
import { toast } from 'react-toastify';
import AssessmentComplete from './AssessmentComplete';
import AssessmentHeader from './AssessmentHeader';
import QuestionInfo from './QuestionInfo';
import VideoRecorder from './VideoRecorder';
import QuestionSideBar from './QuestionSideBar';
import { useLocation, useNavigate } from 'react-router-dom';
import { addItem, clearTable, deleteItem, getAll, getItem, updateItem } from '../../app/services/indexedDBService';
import OccyIcon from '../../app/components/svgIcons/OccyIcon';
import ProfileVideoHeader from './ProfileVideoHeader';
import { useWindowSize } from '../../utils/helper';
import CircularProgress from './CircularProgress';
import PlayIcon from '../../app/components/svgIcons/PlayIcon';
import PauseIcon from '../../app/components/svgIcons/PauseIcon';
import moment from 'moment';
import TimesUpModal from '../Setting/VideoProfiling/TimesUpModal';

const ProfileVideo = () => {

  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [readyForAssessment, setReadyForAssessment] = useState(false);
  const [filteredQuestions, setFilteredQuestions] = useState([]);
  const [startAssessment, setStartAssessment] = useState(false);
  const [allAnswered, setAllAnswered] = useState(false);
  const [recordedVideos, setRecordedVideos] = useState([]);
  const [endInterview, setEndInterview] = useState(false);
  const [totalCountdown, setTotalCountdown] = useState(0);
  const [thinkCountdown, setThinkCountdown] = useState();
  const [questionsList, setQuestionsList] = useState([]);
  const [isRecording, setIsRecording] = useState(false);
  const [startRecord, setStartRecord] = useState(true);
  const [retakeCount, setRetakeCount] = useState({});
  const [uploading, setuploading] = useState(false);
  const [allUploadsDone, setAllUploadsDone] = useState(false);
  const [expired, setExpired] = useState(false);

  const [countdown, setCountdown] = useState(3);
  const [phase, setPhase] = useState("idle");
  const thinkCountdownRef = useRef(null);
  const animationFrameRef = useRef(null);
  const [timer, setTimer] = useState(0);
  const mediaRecorderRef = useRef(null);
  const audioContextRef = useRef(null);
  const countdownRef = useRef(null);
  const dataArrayRef = useRef(null);
  const recordedRef = useRef(null);
  const waveformRef = useRef(null);
  const analyserRef = useRef(null);
  const previewRef = useRef(null);
  const streamRef = useRef(null);
  const timerRef = useRef(null);
  const chunksRef = useRef([]);
  const isSmallScreen = useWindowSize();
  const [getPreSignedUrl] = usePreSignedVpUrlMutation();
  const [uploadAnswer, { isLoading: answerLoading }] = useUploadVPAnswerMutation();
  const [submitAnswers, { isLoading: submitLoading }] = useSubmitVideoProfileMutation();
  const [startSession, { isLoading: sessionLoading }] = useStartSessionMutation();
  const [sideBarQuestion, setSideBarQuestion] = useState([])
  const navigate = useNavigate()
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const token = queryParams.get("token");




  useEffect(() => {
    if (!token) {
      navigate('/');
    }
  }, [token, navigate]);

  const {
    data: videoProfileRes,
    isFetching,
    error

  } = useGetClientVideoProfileDetailsQuery(
    {
      token: token,
      noCache: true
    },
    { refetchOnMountOrArgChange: true }
  );



  const {
    data: companyInfo,

  } = useGetCompanyInfoQuery(
    {
      token: token
    },
    { refetchOnMountOrArgChange: true }
  );


  const STORE_NAME = 'uploads'

  const didRunRef = useRef(false);
  const activeList =
    filteredQuestions.length > 0 ? filteredQuestions : questionsList;
  let currentVideo = recordedVideos[currentQuestionIndex];
  const currentQuestion = activeList[currentQuestionIndex];
  const actualIndex = questionsList.findIndex(
    (q) => q.id === currentQuestion?.id
  );

  const [timeLeft, setTimeLeft] = useState(null);
  const [showTimesUp, setShowTimesUp] = useState(false);
  const [progressLoading, setProgressLoading] = useState(false);
  const [progressMap, setProgressMap] = useState({});

  useEffect(() => {
    let interval = setInterval(async () => {
      try {
        const all = await getAll("uploads");

        // 👇 sirf current appId ke records filter karo
        const currentAppId = videoProfileRes?.videoApplication?.id;
        const filtered = all.filter(item => item.appId === currentAppId);

        const obj = {};
        filtered.forEach((item) => {
          obj[item.id] = item;
        });

        setProgressMap(obj);
      } catch (err) {
        console.error('Failed to read upload progress from IndexedDB:', err);
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [videoProfileRes, isSmallScreen]);


  useEffect(() => {
    let interval;
    if (readyForAssessment && timeLeft > 0) {
      interval = setInterval(() => {
        setTimeLeft((prev) => prev - 1);
      }, 1000);
    }

    if ((videoProfileRes?.videoApplication?.allowedTime && timeLeft !== null && timeLeft < 120) && !endInterview && !expired) {
      if (isRecording) {
        stopRecording();
      }
      setShowTimesUp(true);
    }

    if (timeLeft === 0) {
      setTimeLeft(null)
      clearInterval(interval);
      setEndInterview(true);
    }

    return () => clearInterval(interval);
  }, [readyForAssessment, timeLeft]);



  useEffect(() => {

    if (error && "status" in error) {

      if (error?.data?.message.includes("expired")) {
        setExpired(true);
      }
    }
  }, [error])

  useEffect(() => {
    if (videoProfileRes && !didRunRef.current) {
      didRunRef.current = true;
      const qs = videoProfileRes?.videoApplication?.applicationVideoQuestion || [];
      const formattedQs = qs.map((q) => ({
        text: q?.title,
        description: q?.description,
        duration: q?.options?.maxDuration * 60 || 60,
        retakes: q?.options?.retakes,
        answer: q.videoQuestionAnswer,
        thinkTime: q?.options?.prepTime ? q?.options?.prepTime * 60 : 0,
        id: q?.id
      }));
      setQuestionsList(formattedQs);
      const answered = formattedQs.filter(q => q.answer !== null);
      if (answered.length > 0 && answered.length !== qs.length && videoProfileRes?.videoApplication?.isComplete === 0) {
        if (videoProfileRes?.videoApplication?.allowedTime
          ? timeLeft > 120
          : true) {
          setSideBarQuestion(answered);
          setReadyForAssessment(true);
        }
      }
      if (
        videoProfileRes?.videoApplication?.attemptStartedAt &&
        videoProfileRes?.videoApplication?.attemptStartedAt !== null &&
        videoProfileRes?.videoApplication?.isComplete === 0 &&
        answered.length !== qs.length && (videoProfileRes?.videoApplication?.allowedTime
          && timeLeft > 120
        )
      ) {
        const allowedTime = videoProfileRes?.videoApplication?.allowedTime; // in minutes
        const diffSeconds = moment().diff(
          moment(videoProfileRes?.videoApplication?.attemptStartedAt),
          "seconds"
        );

        const allowedSeconds = allowedTime * 60; // convert minutes -> seconds
        const remaining = allowedSeconds - diffSeconds;

        setTimeLeft(remaining > 0 ? remaining : 0); // prevent negative
        setReadyForAssessment(true);
      }
      if (
        videoProfileRes?.videoApplication?.attemptStartedAt &&
        videoProfileRes?.videoApplication?.attemptStartedAt !== null &&
        videoProfileRes?.videoApplication?.isComplete === 0 &&
        answered.length !== qs.length
      ) {
        const allowedTime = videoProfileRes?.videoApplication?.allowedTime; // in minutes
        const diffSeconds = moment().diff(
          moment(videoProfileRes?.videoApplication?.attemptStartedAt),
          "seconds"
        );

        const allowedSeconds = allowedTime * 60; // convert minutes -> seconds
        const remaining = allowedSeconds - diffSeconds;
        setTimeLeft(remaining > 0 ? remaining : 0); // prevent negative

      }
      if (
        videoProfileRes?.videoApplication?.attemptStartedAt &&
        videoProfileRes?.videoApplication?.attemptStartedAt !== null &&
        videoProfileRes?.videoApplication?.isComplete === 0 &&
        answered.length === qs.length
      ) {
        const allowedTime = videoProfileRes?.videoApplication?.allowedTime; // in minutes
        const diffSeconds = moment().diff(
          moment(videoProfileRes?.videoApplication?.attemptStartedAt),
          "seconds"
        );

        const allowedSeconds = allowedTime * 60; // convert minutes -> seconds
        const remaining = allowedSeconds - diffSeconds;
        setTimeLeft(remaining > 0 ? remaining : 0); // prevent negative

      }
      if (timeLeft !== null && timeLeft < 120) {
        setExpired(true)
        setShowTimesUp(false)
      }
      videoProfileRes && deleteUnansweredUploads(formattedQs);
    }
  }, [videoProfileRes]);

  useEffect(() => {
    if (readyForAssessment && !endInterview) {
      initCamera();

      const thinkTime = currentQuestion?.thinkTime;
      if (thinkTime > 0) {
        setPhase("thinking");
        setThinkCountdown(thinkTime);

        thinkCountdownRef.current = setInterval(() => {
          setThinkCountdown((prev) => {
            if (prev <= 1) {
              clearInterval(thinkCountdownRef.current);
              setPhase("recording");
              setCountdown(3);
            }
            return prev - 1;
          });
        }, 1000);
      } else {
        setPhase("recording");
        setCountdown(3);
      }
    }

    return () => {
      clearInterval(thinkCountdownRef.current);
      // streamRef.current?.getTracks().forEach((track) => track.stop());
    };
  }, [readyForAssessment, currentQuestionIndex]);

  const skipPreparation = () => {
    setThinkCountdown(0);
    setPhase("recording");
    setCountdown(3);
  }

  useEffect(() => {
    if (phase === "recording" && countdown > 0) {
      setTotalCountdown(countdown);
      countdownRef.current = setInterval(() => {
        setCountdown((prev) => {
          if (prev <= 1) {
            clearInterval(countdownRef.current);
            startRecording();
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
    }

    return () => clearInterval(countdownRef.current);
  }, [phase, countdown]);


  useEffect(() => {
    const allAnswered = questionsList?.every((q) => q.answer !== null);
    setAllAnswered(allAnswered)

    if (!allAnswered) {
      const unanswered = questionsList?.filter((q) => q.answer === null);
      setFilteredQuestions(unanswered);
    } else {
      setFilteredQuestions([]);
    }
  }, [questionsList]);

  useEffect(() => {
    let interval;
    if (isRecording) {
      interval = setInterval(() => {
        setTimer((prev) => {
          if (prev - 1 <= 0) {
            clearInterval(interval);
            setIsRecording(false);
            stopRecording()
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
    }
    return () => clearInterval(interval);
  }, [isRecording]);

  useEffect(() => {
    if (activeList[currentQuestionIndex]) {
      setSideBarQuestion(prev => {
        const exists = prev.find(q => q.id === activeList[currentQuestionIndex].id);
        if (exists) return prev;
        return [...prev, activeList[currentQuestionIndex]];
      });
    }
  }, [currentQuestionIndex, activeList]);

  const stopMedia = () => {
    try {
      // Stop recording if active
      if (mediaRecorderRef.current && mediaRecorderRef.current.state !== "inactive") {
        mediaRecorderRef.current.stop();
        mediaRecorderRef.current = null;

      }

      // Stop all tracks (camera + mic)
      if (streamRef.current) {
        streamRef.current.getTracks().forEach(track => track.stop());
        streamRef.current = null;
      }
      if (previewRef.current) {
        previewRef.current.srcObject = null;   // ✅ force video element to release camera
      }

      // Cancel waveform animation
      if (animationFrameRef.current) {
        cancelAnimationFrame(animationFrameRef.current);
        animationFrameRef.current = null;
      }

      // Close audio context
      if (audioContextRef.current) {
        audioContextRef.current.close().catch(() => { });
        audioContextRef.current = null;
      }
    } catch (err) {
      console.error("Error stopping media:", err);
    }
  };


  useEffect(() => {
    if (!videoProfileRes) return;

    const interval = setInterval(async () => {
      const uploads = await getAll("uploads");
      const incomplete = uploads?.some(u => u?.status !== "uploaded");
      setAllUploadsDone(!incomplete);
    }, 1000);

    return () => clearInterval(interval);
  }, [videoProfileRes]);

  const initCamera = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({
        video: { facingMode: 'user', width: { ideal: 1080 }, height: { ideal: 720 } },
        audio: true,
      });
      streamRef.current = stream;

      if (previewRef.current) {
        previewRef.current.srcObject = stream;
        previewRef.current.muted = true;
        previewRef.current.playsInline = true;
        await previewRef.current.play().catch(() => { });
      }

      // waveform init
      audioContextRef.current = new (window.AudioContext || window.webkitAudioContext)();
      const source = audioContextRef.current.createMediaStreamSource(stream);
      analyserRef.current = audioContextRef.current.createAnalyser();
      analyserRef.current.fftSize = 2048;
      const bufferLength = analyserRef.current.frequencyBinCount;
      dataArrayRef.current = new Uint8Array(bufferLength);
      source.connect(analyserRef.current);
      drawWaveform();
    } catch (err) {
      console.error("Camera init error:", err);
      alert("Camera or mic access denied.");
      setStartRecord(false);
    }
  };


  const drawWaveform = () => {
    if (!waveformRef.current) return; // canvas not ready
    const canvas = waveformRef.current;
    const canvasCtx = canvas.getContext('2d');
    if (!canvasCtx || !analyserRef.current) return;

    const draw = () => {
      animationFrameRef.current = requestAnimationFrame(draw);

      analyserRef.current.getByteTimeDomainData(dataArrayRef.current);

      canvasCtx.fillStyle = '#0a2d39';
      canvasCtx.fillRect(0, 0, canvas.width, canvas.height);

      canvasCtx.lineWidth = 2;
      canvasCtx.strokeStyle = '#fff';

      canvasCtx.beginPath();

      const sliceWidth = (canvas.width * 1.0) / dataArrayRef.current.length;
      let x = 0;

      for (let i = 0; i < dataArrayRef.current.length; i++) {
        const v = dataArrayRef.current[i] / 128.0;
        const y = (v * canvas.height) / 2;

        if (i === 0) {
          canvasCtx.moveTo(x, y);
        } else {
          canvasCtx.lineTo(x, y);
        }

        x += sliceWidth;
      }

      canvasCtx.lineTo(canvas.width, canvas.height / 2);
      canvasCtx.stroke();
    };

    draw();
  };

  const startTimer = (limit) => {
    setTimer(limit);      // bas limit set karo
  };

  const stopTimer = () => {
    if (timerRef.current) {
      clearInterval(timerRef.current);
      timerRef.current = null;
    }
  };


  const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  function pickMime() {
    // Prefer a format the *browser can both record and play*.
    const v = document.createElement('video');
    const canMp4 = v.canPlayType('video/mp4; codecs="avc1.42E01E, mp4a.40.2"');
    const canWebm = v.canPlayType('video/webm; codecs="vp8, opus"') || v.canPlayType('video/webm');

    // Safari/iOS: MP4 works; WebM usually doesn't.

    if (isSafari && MediaRecorder.isTypeSupported?.('video/mp4') && canMp4) {
      return { mime: 'video/mp4', fileExt: 'mp4' };
    }
    // Chrome/Edge/Firefox/Android: WebM VP8/Opus is safe.
    if (MediaRecorder.isTypeSupported?.('video/webm;codecs=vp8,opus') && canWebm) {
      return { mime: 'video/webm;codecs=vp8,opus', fileExt: 'webm' };
    }
    if (MediaRecorder.isTypeSupported?.('video/webm') && canWebm) {
      return { mime: 'video/webm', fileExt: 'webm' };
    }
    // Fallback: try bare mp4 if advertised
    if (MediaRecorder.isTypeSupported?.('video/mp4') && canMp4) {
      return { mime: 'video/mp4', fileExt: 'mp4' };
    }
    // Last resort
    return { mime: '', fileExt: 'webm' };
  }

  const startRecording = () => {
    if (!streamRef?.current) return alert('Camera not ready');

    const { mime } = pickMime();
    if (!mime) {
      alert("Your browser doesn't support a compatible recording format.");
      return;
    }

    chunksRef.current = [];
    const options = { mimeType: mime };
    const mediaRecorder = new MediaRecorder(streamRef.current, options);

    mediaRecorderRef.current = mediaRecorder;

    mediaRecorder.ondataavailable = (e) => {
      if (e.data.size > 0) {
        chunksRef.current.push(e.data);
      }
    };

    mediaRecorder.onstop = () => {
      try {
        const blob = new Blob(chunksRef.current, { type: mime });
        const url = URL.createObjectURL(blob);

        const updated = [...recordedVideos];
        updated[currentQuestionIndex] = { blob, url };
        setRecordedVideos(updated);

        if (recordedRef.current) {
          recordedRef.current.src = url;
        }
      } catch (err) {
        console.error(err);
      } finally {
        chunksRef.current = [];
      }
    };

    mediaRecorder.start(1000);
    setIsRecording(true);
    const currentDuration = activeList[currentQuestionIndex]?.duration || 60;
    startTimer(currentDuration);
  };

  const stopRecording = () => {
    if (mediaRecorderRef.current && mediaRecorderRef.current.state !== "inactive") {
      mediaRecorderRef.current.stop(); // ✅ MUST call stop
    }
    stopMedia();
    setIsRecording(false);
    stopTimer();
    setStartRecord(false);
  };

  const handleRetake = async () => {
    setStartRecord(true);

    const qId = activeList[currentQuestionIndex]?.id;
    const maxRetakes = activeList[currentQuestionIndex]?.retakes;

    // Get current retakes count
    const currentRetakes = retakeCount[qId] || 0;

    if (currentRetakes >= maxRetakes) {
      toast.warn("No retakes left for this question.");
      return;
    }

    // Increment retakes count
    setRetakeCount((prev) => ({
      ...prev,
      [qId]: currentRetakes + 1,
    }));
    stopTimer();
    setTimer(null);
    // Cancel waveform animation
    if (animationFrameRef.current) {
      cancelAnimationFrame(animationFrameRef.current);
      animationFrameRef.current = null;
    }

    // Close audio context if exists
    if (audioContextRef.current) {
      await audioContextRef.current.close().catch(() => { });
      audioContextRef.current = null;
    }

    // Stop all tracks
    streamRef.current?.getTracks().forEach((track) => track.stop());
    streamRef.current = null;
    try {
      const stream = await navigator.mediaDevices.getUserMedia({
        video: { facingMode: 'user', width: { ideal: 1080 }, height: { ideal: 720 }, },
        audio: true,
      });
      streamRef.current = stream;
      if (previewRef.current) {
        previewRef.current.srcObject = stream;
        previewRef.current.muted = true; // mute live preview to avoid feedback
        previewRef.current.playsInline = true;
        previewRef.current.load?.();
        await previewRef.current.play().catch(() => { });
      }
      audioContextRef.current = new (window.AudioContext ||
        window.webkitAudioContext)();
      const source = audioContextRef.current.createMediaStreamSource(stream);
      analyserRef.current = audioContextRef.current.createAnalyser();

      analyserRef.current.fftSize = 2048;
      const bufferLength = analyserRef.current.frequencyBinCount;
      dataArrayRef.current = new Uint8Array(bufferLength);

      source.connect(analyserRef.current);
      drawWaveform();
      startRecording();
    } catch (err) {
      console.error('Camera error:', err);
      alert('Camera or mic access denied.');
      setStartRecord(false);
    }
  };

  const uploadToS3 = (file, presignedUrl, questionId, onProgress) => {
    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.open("PUT", presignedUrl.url, true);
      xhr.setRequestHeader("Content-Type", file?.blob?.type);
      const fileSize = (file?.blob?.size / (1024 * 1024)).toFixed(2) + ' MB'

      // Progress event
      xhr.upload.onprogress = async (event) => {
        if (event.lengthComputable && onProgress) {
          setProgressLoading(true)
          const percentComplete = Math.round((event.loaded / event.total) * 100);
          onProgress(percentComplete);

          await updateItem(STORE_NAME, {
            id: questionId,
            file,
            presignedUrl,
            appId: videoProfileRes?.videoApplication?.id,
            progress: percentComplete,
            fileSize: fileSize,
            status: "uploading",
          });
        }
      };

      xhr.onload = async () => {
        if (xhr.status === 200) {

          setProgressLoading(false);
          await updateItem(STORE_NAME, {
            id: questionId,
            file,
            presignedUrl,
            appId: videoProfileRes?.videoApplication?.id,
            progress: 100,
            fileSize: fileSize,
            status: "uploaded",
          });

          uploadAnswer({
            token: token,
            questionId,
            fileDescriptor: presignedUrl.key,

          });
          resolve("Upload complete!");

        } else {


          await updateItem(STORE_NAME, {
            id: questionId,
            file,
            presignedUrl,
            appId: videoProfileRes?.videoApplication?.id,
            progress: 0,
            fileSize: fileSize,

            status: "failed",
          });
          reject(new Error(`Upload failed with status ${xhr.status}`));
        }
      };

      xhr.onerror = async () => {


        await updateItem(STORE_NAME, {
          id: questionId,
          file,
          presignedUrl,
          appId: videoProfileRes?.videoApplication?.id,
          progress: 0,
          fileSize: fileSize,

          status: "failed",
        });

        reject(new Error("Upload failed due to an error."));
      }
      xhr.send(file?.blob);
    });
  };


  const handleRetryUpload = async (questionId) => {
    setuploading(true);

    const record = await getItem(STORE_NAME, questionId);
    if (!record || !record.file || !record.presignedUrl) {
      return toast.error("No file found in DB for retry");
    }

    await updateItem(STORE_NAME, {
      ...record,
      progress: 0,
      appId: videoProfileRes?.videoApplication?.id,
      fileSize: record?.fileSize,
      status: "uploading",
    });

    return uploadToS3(record.file, record.presignedUrl, questionId, async (percent) => {
      await updateItem(STORE_NAME, {
        ...record,
        progress: percent,
        appId: videoProfileRes?.videoApplication?.id,
        fileSize: record?.fileSize,
        status: "uploading",
      });
    });

    // uploadToS3(file, presignedUrl, (percentComplete) => {
    //   setProgressMap(prev => ({
    //     ...prev,
    //     [questionId]: { progress: percentComplete, status: "uploading", file, presignedUrl }
    //   }));
    // })
    //   .then(() => {
    //     setProgressMap(prev => ({
    //       ...prev,
    //       [questionId]: { progress: 100, status: "uploaded", file, presignedUrl }
    //     }));
    //   })
    //   .catch(() => {
    //     setProgressMap(prev => ({
    //       ...prev,
    //       [questionId]: { progress: 0, status: "failed", file, presignedUrl }
    //     }));
    //   });
  };


  const SaveAnswer = async () => {


    setuploading(true)
    setTimer(null);
    setStartRecord(false);
    const questionId = activeList[currentQuestionIndex]?.id;
    const fileSize = (currentVideo?.blob?.size / (1024 * 1024)).toFixed(2) + ' MB'
    const { data: responseData } = await getPreSignedUrl({
      token: token,
      fileName: questionId + (currentVideo.blob.type === 'video/webm;codecs=vp8,opus' || currentVideo.blob.type === 'video/webm' ? '.webm' : '.mp4'),
      fileType: currentVideo?.blob?.type,
    });



    if (!responseData?.url) {
      return toast.error('Could not process the upload. Please make sure the file is valid and the internet connection is stable');
    }

    await addItem(STORE_NAME, {
      id: questionId,
      file: currentVideo,
      presignedUrl: responseData,
      progress: 0,
      fileSize: fileSize,
      status: "pending",
    });

    try {
      await uploadToS3(currentVideo, responseData, questionId, async (percent) => {
        await updateItem(STORE_NAME, {
          id: questionId,
          file: currentVideo,
          presignedUrl: responseData,
          appId: videoProfileRes?.videoApplication?.id,
          progress: percent,
          fileSize: fileSize,
          status: "uploading",
        });
      });
    } catch (err) {
      console.error('Video upload failed:', err);
      toast.error('Upload failed. Please check your connection and try again.');
      setuploading(false);
    }
  };

  const handleNext = () => {


    if (currentQuestionIndex < activeList.length - 1) {
      setProgress(null)
      setCurrentQuestionIndex((prev) => prev + 1);
      setReadyForAssessment(true);
      setStartRecord(true);
      setuploading(false);
      // setPercentage(0)


    }
  };



  const answerSubmit = async () => {

    let values = {
      token: token,
    };


    try {
      const { data } = await submitAnswers(values);
      if (data && isObject(data)) {
        toast.success(
          `${'Answer Saved'
          } Successfully`,
        );
        if (videoProfileRes?.videoApplication?.isComplete === 0) { setReadyForAssessment(true); setAllAnswered(true) }
        setEndInterview(true);
        setTimeLeft(null)

        await clearTable(STORE_NAME);
        stopMedia();
      }
    } catch (e) {
      toast.error('An error occurred while saving the video profile.');
      console.error(e);

    }
    await clearTable(STORE_NAME);
    stopMedia();

  };


  const [progress, setProgress] = useState(null);

  function useUploadProgress(questionId) {

    useEffect(() => {
      if (!questionId) return;

      const fetchProgress = async () => {
        try {
          const data = await getItem(STORE_NAME, questionId);
          if (data) setProgress(data);
        } catch (err) {
          console.error('Failed to read upload progress from IndexedDB:', err);
        }
      };

      videoProfileRes && fetchProgress();

      // har 1s baad progress refresh
      const interval = setInterval(fetchProgress, 100);

      return () => clearInterval(interval);
    }, [questionId]);

    return progress;
  }

  const progressData = useUploadProgress(activeList[currentQuestionIndex]?.id);
  const deleteUnansweredUploads = async (sidebarQuestions) => {
    const unansweredIds = sidebarQuestions
      .filter(q => !q.answer)
      .map(q => q.id);

    if (unansweredIds.length > 0) {
      for (const id of unansweredIds) {
        await deleteItem(STORE_NAME, id);
      }
    }
  };

  const [activeTab, setActiveTab] = useState(1);

  const onChangeTab = (index) => {
    setActiveTab(index)
  }

  const [isPlaying, setIsPlaying] = useState(false);
  const [iosProgress, setIosProgress] = useState(0);


  const togglePlay = () => {
    if (!recordedRef.current) return;
    if (isPlaying) {
      recordedRef.current.pause();
    } else {
      recordedRef.current.play();
    }
    setIsPlaying(!isPlaying);
  };

  const handleTimeUpdate = () => {
    if (!recordedRef.current) return;
    const percent = (recordedRef.current.currentTime / recordedRef.current.duration) * 100;
    setIosProgress(percent);
  };

  const handleSeek = (e) => {
    if (!recordedRef.current) return;
    const newTime = (parseFloat(e.target.value) / 100) * recordedRef.current.duration;
    recordedRef.current.currentTime = newTime;
  };

  const formatTime = (time) => {
    if (!time || isNaN(time)) return "00:00";
    const minutes = Math.floor(time / 60);
    const seconds = Math.floor(time % 60);
    return `${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;
  };


  const handleSaveSubmit = async () => {

    if (!startRecord && currentVideo && (currentQuestionIndex <= activeList.length - 1)) {
      await SaveAnswer();
      await answerSubmit();
    }

    else {
      await answerSubmit();
    }
    setShowTimesUp(false);
  };

  return (
    <>
      {showTimesUp && <div className="overlay"></div>}
      {showTimesUp &&
        <TimesUpModal setReadyForAssessment={setReadyForAssessment} setExpired={setExpired} loading={answerLoading || submitLoading || progressLoading} timeLeft={timeLeft} onSave={handleSaveSubmit} show={showTimesUp} onHide={() => setShowTimesUp(false)} />}
      {readyForAssessment ? (
        <>

          <ProfileVideoHeader companyInfo={companyInfo} videoProfileRes={videoProfileRes}
            timeLeft={timeLeft} />
          {!isSmallScreen &&
            <AssessmentHeader
              videoProfileRes={videoProfileRes}
              timeLeft={timeLeft}
            />}
          <InterviewContainer isSmallScreen={isSmallScreen} className='bg-body'>

            <div className={`d-flex ${isSmallScreen ? 'justify-content-start flex-column gap-2' : 'justify-content-center'} w-100`}
            >
              <div className={`d-flex align-items-center ${isSmallScreen ? 'justify-content-start w-100 flex-column bg-white p-2' : 'justify-content-center'}`}
                style={{ height: isSmallScreen && endInterview ? 'calc(100vh - 83px)' : '' }}
              >
                <div className={`d-flex flex-column ${isSmallScreen && 'w-100'} `}>
                  {(!endInterview && !allAnswered && !uploading && !isSmallScreen) && (
                    <QuestionInfoWrapper>
                      <QuestionInfo questionsList={questionsList} currentQuestion={currentQuestion} />

                    </QuestionInfoWrapper>
                  )}

                  {endInterview && (
                    <AssessmentComplete videoProfileRes={videoProfileRes} />
                  )}



                  {startRecord && !endInterview && (
                    <VideoRecorder questionsList={questionsList} videoProfileRes={videoProfileRes} skipPreparation={skipPreparation} phase={phase} countdown={countdown} thinkCountdown={thinkCountdown} totalCountdown={totalCountdown} startRecord={startRecord} previewRef={previewRef} waveformRef={waveformRef} isRecording={isRecording} endInterview={endInterview} timer={timer} stopRecording={stopRecording} />

                  )}

                  {
                    !isRecording &&
                    currentVideo &&
                    !startRecord &&
                    !endInterview &&
                    (
                      <>
                        <div className="position-relative">

                          <VideoWrapper style={{ position: "relative" }}>
                            <ResponsiveVideo
                              ref={recordedRef}
                              src={currentVideo.url}
                              playsInline
                              controls={!isSafari}
                              style={{
                                width: '100%',
                                height: 'auto',
                                minHeight: '385px',
                                maxHeight: '385px',
                                borderRadius: '16px',
                                marginTop: '2px',
                                marginBottom: '-1px',
                                minWidth: isSmallScreen ? '100%' : '760px',
                                marginLeft: '5px',
                                marginRight: '5px',
                                objectFit: "cover",
                                transform: "scaleX(-1)",

                              }}
                              onTimeUpdate={handleTimeUpdate}
                            />
                            {/* Custom controls only for iPhone Safari */}
                            {isSafari && (
                              <div
                                style={{
                                  position: "absolute",
                                  bottom: "10px",
                                  left: '50%',
                                  transform: 'translateX(-50%)',
                                  right: 0,
                                  display: "flex",
                                  width: "80%",
                                  alignItems: "center",
                                  justifyContent: "space-between",
                                  padding: "6px 10px",
                                  background: "rgba(0,0,0,0.6)",
                                  borderRadius: "16px",
                                }}
                              >
                                <div onClick={togglePlay} style={{ color: "white" }}>
                                  {isPlaying ? <PauseIcon /> : <PlayIcon />}
                                </div>
                                <input
                                  type="range"
                                  min="0"
                                  max="100"
                                  value={iosProgress}
                                  onChange={handleSeek}
                                  style={{ flex: 1, margin: "0 10px", }}
                                />
                                <span style={{ color: "white", fontSize: "12px" }}>
                                  {recordedRef.current
                                    ? `${formatTime(recordedRef.current.currentTime)} / ${formatTime(
                                      recordedRef.current.duration
                                    )}`
                                    : "00:00 / 00:00"}
                                </span>
                              </div>
                            )}
                            {!isSafari && <style>
                              {`
      video {
        transform: scaleX(-1);
      }
      video::-webkit-media-controls {
        transform: scaleX(-1); /* controls dobara seedhe */
      }
    `}
                            </style>}

                          </VideoWrapper>


                          {uploading && progressData?.progress !== undefined && (
                            <StyledUpload isSmallScreen={isSmallScreen}>
                              <div className="d-flex align-items-center gap-2 w-100">
                                {progressData?.progress === 100 ? <OccyIcon size={35} /> : <Spinner width="40px" height="40px" />}
                                <div className="d-flex flex-column gap-1 w-100">
                                  <StyledLabel className="w-100">
                                    {progressData?.progress}% Uploaded
                                  </StyledLabel>
                                  <div className="progress w-100" style={{ height: "6px" }}>
                                    <div
                                      className="progress-bar bg-success"
                                      role="progressbar"
                                      style={{ width: `${progressData.progress}%` }}
                                      aria-valuenow={progressData?.progress}
                                      aria-valuemin={0}
                                      aria-valuemax={100}
                                    />
                                  </div>
                                </div>
                              </div>
                            </StyledUpload>
                          )}

                          {!uploading && <StyledDownload
                            href={currentVideo.url}
                            download={`answer-q${currentQuestionIndex + 1}.webm`}
                          >
                            <DownloadIcon color="black" size={18} />
                          </StyledDownload>}


                        </div>
                        {!uploading && <div className={`d-flex ${isSmallScreen && activeList[currentQuestionIndex]?.retakes > 0 ? 'mt-2 justify-content-center' : isSmallScreen && activeList[currentQuestionIndex]?.retakes === 0 ? 'mt-2 justify-content-between' : "mt-5  justify-content-end"} gap-2 `}>
                          {isSmallScreen &&

                            <CircularProgress count={Object.values(progressMap).filter(item => item.progress === 100 || item.status === "uploaded").length} total={questionsList?.length} />
                          }

                          {activeList[currentQuestionIndex]?.retakes > 0 && (
                            <StyledButton variant={isSmallScreen ? 'border' : 'white'} onClick={handleRetake}
                              disabled={(retakeCount[activeList[currentQuestionIndex]?.id] || 0) >= (activeList[currentQuestionIndex]?.retakes || 0)}>
                              Retake ({(activeList[currentQuestionIndex]?.retakes || 0) - (retakeCount[activeList[currentQuestionIndex]?.id] || 0)} Lefts)
                            </StyledButton>
                          )}
                          {(
                            <StyledButton onClick={SaveAnswer}>
                              Save & Continue
                            </StyledButton>
                          )}

                        </div>}

                        {uploading && <div className='d-flex flex-column align-items-center mt-3'>
                          <StyledLabel size='22px' color={theme?.darktext} className='mt-3'>
                            Uploading Question no. {actualIndex + 1}
                          </StyledLabel>

                          <StyledLabel size='16px' color={theme?.subText} weight='500' className='text-center my-4 w-75'>
                            {currentQuestionIndex === activeList.length - 1 ? 'Please do not close your browser. You have completed all the questions, Once all your recorded answer are uploaded, you can complete the assessment.' : 'Please do not close your browser. You can answer next question, your recorded answer will be uploading in the background'}
                          </StyledLabel>

                          {currentQuestionIndex !== activeList.length - 1 && (
                            <StyledButton onClick={handleNext}>
                              Next Question
                            </StyledButton>
                          )}
                          {currentQuestionIndex === activeList.length - 1 && (
                            <StyledButton disabled={!allUploadsDone} loading={submitLoading} onClick={() => answerSubmit()}>
                              Complete Assessment
                            </StyledButton>
                          )}
                        </div>}
                      </>
                    )}
                </div>
              </div>
              {isSmallScreen && !endInterview && <div className='d-flex flex-column bg-white p-2 overflow-y-scroll' style={{ height: 'calc(100vh - 505px)' }}>
                <div className='d-flex justify-content-center mb-3'>
                  {[{ name: 'About Question', id: 1 }, { name: 'Attempted Questions', id: 2 }].map((tab) =>
                  (<StyledLabel className={`p-2 rounded `} weight={activeTab === tab?.id ? 600 : 400} color={activeTab === tab?.id ? theme?.secondary : theme?.darktext} size={'14px'} bgColor={activeTab === tab?.id ? '#E966181A' : ''} onClick={() => onChangeTab(tab?.id)}> {tab.name}
                  </StyledLabel>))}

                </div>
                {activeTab === 1 ? <QuestionInfo questionsList={questionsList} currentQuestion={currentQuestion} isSmallScreen={isSmallScreen} /> :
                  <QuestionSideBar videoProfileRes={videoProfileRes} handleRetryUpload={(id) => handleRetryUpload(id)} doneQuestions={sideBarQuestion} questionsList={questionsList} isSmallScreen={isSmallScreen} />}
              </div>}
            </div>
            {!endInterview && !isSmallScreen &&
              <QuestionSideBar videoProfileRes={videoProfileRes} handleRetryUpload={(id) => handleRetryUpload(id)} doneQuestions={sideBarQuestion} questionsList={questionsList} />}
          </InterviewContainer>

        </>
      ) :
        (<>
          {(() => {
            let content;
            let doneContent = <>
              <ProfileVideoHeader timeLeft={timeLeft} videoProfileRes={videoProfileRes} companyInfo={companyInfo} />
              <PageContainer>
                <InterviewDone message={error?.data?.message} expired={expired} videoProfileRes={videoProfileRes} submitLoading={submitLoading} answerSubmit={answerSubmit} /> </PageContainer></>

            if (!isFetching) {
              if (allAnswered && !expired && videoProfileRes?.videoApplication?.isComplete === 1) {

                content = doneContent;
              } else if ((!allAnswered && videoProfileRes?.videoApplication?.isComplete === 1) || (!allAnswered && videoProfileRes?.videoApplication?.isComplete === 0 && timeLeft !== null && timeLeft < 120)) {

                content = doneContent;
              }
              else if (expired || (timeLeft !== null && timeLeft < 120)) {

                content = doneContent

              }
              else if (allAnswered && videoProfileRes?.videoApplication?.isComplete === 0 && videoProfileRes?.videoApplication?.allowedTime === null) {

                content = doneContent

              } else if (startAssessment) {

                content = <>
                  <ProfileVideoHeader videoProfileRes={videoProfileRes} timeLeft={timeLeft} companyInfo={companyInfo} />
                  <GettingReadyAssessment setTimeLeft={setTimeLeft} token={token} sessionLoading={sessionLoading} startSession={startSession} data={videoProfileRes} setReadyForAssessment={setReadyForAssessment} /></>
              }
              else {
                content =
                  <>
                    {isSmallScreen && <ProfileVideoHeader videoProfileRes={videoProfileRes} timeLeft={timeLeft} companyInfo={companyInfo} />}
                    <StartInterviewScreen companyInfo={companyInfo} data={videoProfileRes} setStartAssessment={setStartAssessment} />
                  </>
              }
            } else {
              content =
                <PageContainer2> <WelcomeVideoProfile /></PageContainer2>

            }
            return content;
          })()}
        </ >
        )
      }
    </>
  );
};





const InterviewContainer = styled.div`
  // width: 100%;
  display: flex;
  height:${({ isSmallScreen }) => `calc(100vh - ${isSmallScreen ? '--85px' : '161px'})`};
  align-items: center;
background: #FFFFFF05;
    //  padding:${({ isSmallScreen }) => isSmallScreen ? '0px' : '16px'};
 
`;



const VideoWrapper = styled.div`
  // width: 100%;
  max-width:${({ isSmallScreen }) => isSmallScreen ? '100%' : '765px'};
  margin: 0 auto;
  position: relative;
  min-width:${({ isSmallScreen }) => isSmallScreen ? '100%' : '765px'};
  height: 390px;   /* ✅ Fixed height */
  border-radius: 16px;
  overflow: hidden;

  @media (max-width: 768px) {
    min-width: 100%;
    height: auto;  /* mobile pe adjust ho sake */
  }
`;




const ResponsiveVideo = styled.video`
  width: 100%;
  height: 100%;  /* ✅ force fill height */
  object-fit: cover;
  border-radius: 16px;
  background-color: #000;
`;

const StyledDownload = styled.a`
  position: absolute;
  top: 5%;
  right: 30px;
  padding: 5px 7px;
  color: white;
  font-size: 0.875rem;
  border-radius: 9999px;
  transition: background-color 0.2s ease;
  background:#fff;
  max-height:35px;
 


`;

export const PageContainer = styled.div`
  width: 100%;
  height: calc(100vh - 83px);
  justify-content: center;
  // background: linear-gradient(
  //   118.77deg,
  //   #0d2349 -14.45%,
  //   #222235 57.39%,
  //   #1e1e1f 98.79%
  // );
background:#fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  @media (max-width: 768px) {
    padding: 16px;
    justify-content: start;
  }
`;

const PageContainer2 = styled.div`
  width: 100%;
  height:100vh;
  justify-content: center;
background:#fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  @media (max-width: 768px) {
    padding: 16px;
    justify-content: start;
  }
`;



const QuestionInfoWrapper = styled.div`
 width: 100%;
 display:flex;
 align-item:center;
  max-width: 765px;   /* same as player */
  min-width: 765px;   /* to keep alignment same */
  margin-bottom: 20px; 
  text-align: left;
`;

const StyledUpload = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  bottom: 40px;
  left: 50%;
  transform: translateX(-50%);  /* ✅ Center horizontally */
  width:${({ isSmallScreen }) => isSmallScreen ? '75%' : '420px'};
  height: 55px;
  border-radius: 6px;
  padding: 10px;
  background: linear-gradient(
    90deg,
    #ffffff 0%,
    rgba(255, 255, 255, 0.57) 39.9%
  );
  backdrop-filter: blur(12px);
`;

export default ProfileVideo;
